import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import DashboardLayout from "./layouts/DashboardLayout";
import GoldPriceUpdater from "./pages/GoldPriceUpdater";
import Login from "./pages/Login";

// Authentication service (same as in Login component)
const authService = {
  getCurrentUser: () => {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      return JSON.parse(userStr);
    }
    return null;
  }
};

// Protected route component
const ProtectedRoute = ({ children }) => {
  const [checking, setChecking] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const userStr = localStorage.getItem("user");
    const token = localStorage.getItem("auth_token");

    if (userStr && token) {
      try {
        const user = JSON.parse(userStr);
        if (user && token) {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      } catch {
        setIsAuthenticated(false);
      }
    } else {
      setIsAuthenticated(false);
    }

    setChecking(false);
  }, []);

  if (checking) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

function Home() {
  return (
    <div className="bg-white p-6 rounded-xl shadow">
      <h1 className="text-2xl font-semibold text-gray-800 mb-2">
        Welcome to MBB Dashboard
      </h1>
      <p className="text-gray-600">Monitor gold prices and updates in real-time.</p>
    </div>
  );
}

function UpdatePage() {
  return (
    <div className="bg-white p-6 rounded-xl shadow">
      <h1 className="text-2xl font-semibold text-gray-800 mb-2">
        Update Price
      </h1>
      <p className="text-gray-600">Coming soon...</p>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={
          <ProtectedRoute>
            <DashboardLayout>
              <Home />
            </DashboardLayout>
          </ProtectedRoute>
        } />
        <Route path="/scrab" element={
          <ProtectedRoute>
            <DashboardLayout>
              <GoldPriceUpdater />
            </DashboardLayout>
          </ProtectedRoute>
        } />
        <Route path="/update" element={
          <ProtectedRoute>
            <DashboardLayout>
              <UpdatePage />
            </DashboardLayout>
          </ProtectedRoute>
        } />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}